// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__fTuX5","load6":"Spinner_load6__1_74m","round":"Spinner_round__3G_CY"};